module.exports = __webpack_public_path__ + "img/hf_e.118186c8.png";